var dragged = false;

if (Number.isFinite === undefined) Number.isFinite = function(value) {
 return typeof value === 'number' && isFinite(value);
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

$('body')
  .on('touchmove', function() {
    dragged = true;
  })
  .on('touchstart', function() {
    dragged = false;
  });

Date.prototype.yyyymmdd = function() {
  var yyyy = this.getFullYear().toString(),
    mm = (this.getMonth() + 1).toString(),
    dd = this.getDate().toString();
  return yyyy + (mm[1] ? mm : '0' + mm[0]) + (dd[1] ? dd : '0' + dd[0]);
};

var wf = {
  loadingIcon:
    '<img src="/wp-content/themes/westfield/images/icon-loading.svg">',
  searchIcon:
    '<svg class="icon icon-search"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-search"></use></svg>',
  cookie: function(name, value, days) {
    if (value === undefined) {
      var cookiestring = '; ' + window.document.cookie;
      var cookies = cookiestring.split('; ' + name + '=');
      if (cookies.length === 2) {
        return cookies
          .pop()
          .split(';')
          .shift();
      }
      return null;
    } else {
      if (value === false) {
        days = -1;
      }
      var expires;
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
      } else {
        expires = '';
      }
      window.document.cookie = name + '=' + value + expires + '; path=/';
    }
  },
  products: {
    init: function() {
      wf.products.restrictOrderByRetailer();
      wf.products.showAlert();
      wf.products.hideAlert();
      wf.products.handleClearCart();
    },
    restrictOrderByRetailer: function() {
      jQuery("button[name=add-to-cart]").on('click', function () {
        var retailerId = $(this).data('sku').split('-')[0];
        wf.cookie('selectedRetailer', retailerId, 30);
      })
    },
    clearSelectedRetailer: function() {
      wf.cookie('selectedRetailer', false);
    },
    showAlert: function() {
      $(".retailer-menu-item").on('click', function(e) {
        e.preventDefault();
        var retailerId = $(this).data('sku').split('-')[0];
        var selectedRetailer = wf.cookie('selectedRetailer');
        var productUrl = $(this).attr('href');
        console.log(productUrl);

        $(".grab-modal").addClass("grab-modal--active");

        if(selectedRetailer && selectedRetailer !== retailerId) {
          $(".grab-modal__clear-cart").data('url', productUrl);
        } else {
          window.location = productUrl;
        }
      });
      // var popup = '<div class="alert alert-popup';
      // $("body").append('');
    },
    hideAlert: function() {
      $(".grab-modal__dismiss").on('click', function() {
        $(".grab-modal").removeClass('grab-modal--active');
      });
    },
    handleClearCart: function() {
      $(".grab-modal__clear-cart").on('click', function() {
        wf.products.clearCart($(this).data('url'));
      });
    },
    clearCart: function(productUrl = null) {
      console.log('clear cart');
      jQuery.post(
        window.ajax_url,
        { "action": "clearcart", "data": 1 },
        function(res){
          console.log(res);
          wf.products.clearSelectedRetailer();
          if(productUrl){
            window.location = productUrl;
          }
        }
      );
    }
  },
  flights: {
    airportCode: $('body').data('site-shortcode'),
    apiURL: '/wp-content/themes/westfield/flightLookup.php',
    arrivals: null,
    arrivalDeparture: 'dep',
    date: '',
    secondaryDate: '',
    departures: null,
    trackedFlight: null,
    supportedTerminals: $('body').data('supported-terminals'),
    // init: function(){
    // 	wf.flights.cleanupStoredData();
    // 	wf.flights.setupFlightSearch();
    // 	wf.flights.getFlights();
    // 	// wf.flights.flightSearch();
    // 	wf.flights.hideTrackedFlight();
    // 	wf.flights.loadFlightList();
    // 	wf.flights.loadJourneyPage();
    // 	wf.flights.loadTrackedFlight();
    // 	wf.flights.toggleArrivalDepartures();
    // 	wf.flights.trackFlightFromList();
    // },
    // cleanupStoredData: function(){
    // 	// if( wf.cookie( wf.flights.airportCode + '_garbageCleanup') !== null && wf.cookie( wf.flights.airportCode + '_journeyTrackerUpdate') !== null ){ return; }
    //
    // 	var flightIDs = [], renderedFlights = [];
    //
    // 	for(var i = 0; i < localStorage.length; i++){
    // 		var key = localStorage.key( i );
    //
    // 		if( key.match(/journey_trackedFlightHtml_|trackedFlightHtml_/) ){
    // 			renderedFlights.push( key );
    // 		} else if( key.match(/flights_trackedFlight/) ) {
    // 			if( !key.match(/_flights_trackedFlight$/) ){
    // 				flightIDs.push( key.split('flights_trackedFlight_')[1] );
    // 			}
    //
    // 			if( key.match(/ID|Type/) ){ continue; }
    //
    // 			var flight = JSON.parse( localStorage[key] ),
    // 					date = new Date( flight.departure.date.original ),
    // 					now = new Date();
    //
    // 			now.setDate(now.getDate() - 2);
    //
    // 			if( now > date ){
    // 				localStorage.removeItem(key);
    //
    // 				if( key.match(/_flights_trackedFlight$/) ){
    // 					localStorage.removeItem( wf.flights.airportCode + '_flights_trackedFlightID' );
    // 					localStorage.removeItem( wf.flights.airportCode + '_flights_trackedFlightType' );
    // 				}
    // 			}
    //
    //       if( wf.cookie( wf.flights.airportCode + '_journeyTrackerUpdate') == null ){
    //         localStorage.removeItem(key);
    //
    // 				if( key.match(/_flights_trackedFlight$/) ){
    // 					localStorage.removeItem( wf.flights.airportCode + '_trackedFlightHtml_default' );
    // 				}
    //       }
    // 		}
    // 	}
    //
    // 	for( var j = 0; j < flightIDs.length; j++ ){
    // 		renderedFlights.pop( wf.flights.airportCode + '_journey_trackedFlightHtml_' + flightIDs[j]);
    // 		renderedFlights.pop( wf.flights.airportCode + '_trackedFlightHtml_' + flightIDs[j]);
    // 	}
    //
    // 	for(var k = 0; k < renderedFlights.length; k++){
    // 		localStorage.removeItem( renderedFlights[k] );
    // 	}
    //
    // 	wf.cookie( wf.flights.airportCode + '_garbageCleanup', '', 1 );
    // 	wf.cookie( wf.flights.airportCode + '_journeyTrackerUpdate', '', 1 );
    // },
    // setupFlightSearch: function(){
    // 	var location = window.location.pathname.split('/').filter(Boolean),
    // 			fullDate = $('body').data('date').toString(),
    // 			date = fullDate.substring(0, fullDate.length -5),
    // 			secondaryDate = new Date( date );
    // 			secondaryDate.setDate( secondaryDate.getDate() + 1 );
    //
    // 			wf.flights.secondaryDate = secondaryDate.yyyymmdd();
    // 			wf.flights.date = date.replace(/\//g,'');
    //
    // 	if( location.indexOf('arrive') > -1 || $(".flights-nav").length && $(".flights-nav a[href='#arrivals'].active").length ){
    // 		wf.flights.arrivalDeparture = 'arr';
    // 	}
    // },
    // getFlights: function(callback) {
    //   var dateTime = $('body').data('date').toString();
    //   var date = dateTime.substring(0, dateTime.length - 5).replace(/\//g,'');
    //   var hour = dateTime.substring(dateTime.length - 4);
    //
    //   wf.flights.getDepartures( date, hour, callback );
    //   wf.flights.getArrivals( date, hour, callback );
    // },
    // // flightSearch: function(){
    // // 	if( !$(".flight-search").length ){ return; }
    // //
    // //   var dateTime = $('body').data('date').toString(),
    // // 			date = dateTime.substring(0, dateTime.length - 5).replace(/\//g,''),
    // // 			hour = dateTime.substring(dateTime.length - 4);
    // // 			date = date.replace(/\//g,'');
    // //
    // //   wf.flights.getDepartures( date, hour );
    // //   wf.flights.getArrivals( date, hour );
    // //
    // //   $(".flight-search").append('<div class="flight-search-suggestions"></div>');
    // //
    // //   var timeoutID = 0;
    // //   $('.flight-search .flightID').on('keyup', function(){
    // //     var query = $(this).val();
    // //
    // //     if( query.length > 1 ){
    // //       clearTimeout(timeoutID);
    // //       timeoutID = setTimeout(function(){
    // //         wf.flights.getFlightSuggestions( query );
    // //       }, 500);
    // //     }
    // //   });
    // //
    // //   $(document).on('touchend click', '.flight-search-suggestions li', function(){
    // //     if(dragged){ return; }
    // //     $(".flight-search .flightID").val( $(this).find('strong').text() );
    // //     $(".flight-list tr").removeClass('tracked-flight');
    // //     $(".flight-list.active [data-flight-index=\"" + $(this).data('flight-index') + "\"]").addClass('tracked-flight');
    // //     setTimeout(function(){
    // //       $(".flight-search-suggestions ul").remove();
    // //     }, 250);
    // //
    // //     $(".flight-search").submit();
    // //   });
    // //
    // //   $(".flight-search").submit(function(event){
    // //     event.preventDefault();
    // //     $(".flight-search .error").remove();
    // //     var flightID = $(this).find('.flightID').val().replace(/\s*\**/g,'').toUpperCase();
    // //     // if( !flightID.length || !flightID.match(/^[A-Z]{2,3}\d{1,4}$/) ){
    // //     // 	$(".flight-search").prepend('<div class="error">Please enter a valid flight number.');
    // //     // 	return;
    // //     // }
    // //
    // //     $(this).find('input,button').prop('disabled', true);
    // //     $(this).find('button').html(wf.loadingIcon);
    // //     wf.flights.getFlightByID( flightID, wf.flights.date, wf.flights.secondaryDate, wf.flights.arrivalDeparture, wf.flights.parseTrackedFlight );
    // //   });
    // // },
    // getFlightSuggestions: function( query ){
    //   var flightSuggestions = [];
    //   var flights = wf.flights.departures.flights.concat(wf.flights.arrivals.flights);
    //
    //   flights.forEach(function(flight) {
    //     var flightId = flight.flightID.split(':')[0];
    //     var airline = flight.airline;
    //     var regex = new RegExp(query, 'i');
    //     var matchAirline = airline.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //     var matchFlightId = flightId.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //
    //     if(matchAirline && !flightSuggestions.filter(function(fs) { return fs.airline === airline }).length) {
    //       flight.suggestionType = 'airline';
    //       flightSuggestions.push(flight);
    //     } else if(matchFlightId) {
    //       flight.suggestionType = 'flightId';
    //       flightSuggestions.push(flight);
    //     }
    //   });
    //
    //   return flightSuggestions;
    // },
    // formatFlightData: function( flight, flightType, index ){
    //   var time = flight[flightType].time.scheduled.formatted;
    //   var airportCode = '';
    //   var terminal = flight[flightType].terminal || '-';
    //   var gate = flight[flightType].gate || '-';
    //   var status = flight.status;
    //   var flightId = flight.flightID.split(':')[0];
    //   var airlineCode = flight.flightID.split(':')[0].split(flight.flightNumber)[0];
    //
    //   if(flightType === 'departure') {
    //     airportCode = flight.arrival.airportCode;
    //   } else {
    //     airportCode = flight.departure.airportCode;
    //   }
    //
    //   var trackedFlightID = localStorage[ wf.flights.airportCode + '_flights_trackedFlightID' ], trackedFlight = '';
    //   if( trackedFlightID !== undefined && trackedFlightID === flightId ){ trackedFlight = 'tracked-flight'; }
    //
    //   var flightTerminal = terminal === 'TBIT' ? 'tom-bradley-international-terminal' : 'terminal-' + terminal.toLowerCase();
    //   return '<tr data-flight-airlineCode="' + airlineCode + '" data-flight-index="' + index + '" data-terminal="' + flightTerminal + '" class="' + trackedFlight + '"><td>' + time + '</td><td>' + airportCode + '</td><td>' + flightId + '</td><td>' + terminal + ' / ' + gate + '</td><td>' + status + '</td><td></td></tr>';
    // },
    // hideTrackedFlight: function(){
    // 	var toggleEvent = ("ontouchend" in document) ? 'touchstart' : 'click';
    // 	$(document).on(toggleEvent, ".tracked-flight-info-wrapper .close-modal, .clear-flight", function(e){
    // 		e.preventDefault();
    // 		$("body").removeClass('show-tracked-flight');
    // 		$(".tracked-flight-info-wrapper").addClass('hidden');
    //     $("tr.tracked-flight").removeClass('tracked-flight');
    // 		wf.flights.trackedFlight = null;
    // 		localStorage.removeItem(wf.flights.airportCode + '_flights_trackedFlightID');
    // 		localStorage.removeItem( wf.flights.airportCode + '_flights_trackedFlightType' );
    // 		wf.page.departureArrivalRedirect();
    // 	});
    //
    //   $(".clear-flight").on(toggleEvent, function(){
    //     location.reload();
    //   });
    // },
    // getArrivals: function( date, hour, callback ){
    //   var flights = localStorage.getItem(wf.flights.airportCode + '_flights_arrivals')
    // 	if( wf.cookie( wf.flights.airportCode + '_updateArrivals') !== null && flights !== null ) {
    // 		wf.flights.arrivals = JSON.parse( flights );
    //     if( typeof(callback) === "function" ){
    //       callback( wf.flights.arrivals );
    //     }
    //     wf.terminalFilters.filterFlightListing();
    // 	} else {
    // 		$.post(
    // 			wf.flights.apiURL,
    // 			{
    // 				action: 'getFlightsByAirport',
    // 				airportCode: wf.flights.airportCode,
    // 				date: date,
    // 				hour: hour,
    // 				arrivalDeparture: 'arr',
    // 				supportedTerminals: wf.flights.supportedTerminals
    // 			},
    //       function( response ){
    // 				// Set cookie for timer, store data in localStorage
    // 				wf.cookie( wf.flights.airportCode + '_updateArrivals', '', 0.00347222 ); // Cookie for timer
    // 				localStorage.setItem(wf.flights.airportCode + '_flights_arrivals', JSON.stringify( response ));
    // 				wf.flights.arrivals = response;
    //         if( typeof(callback) === "function" ){
    //           callback( wf.flights.arrivals );
    //         }
    //         wf.terminalFilters.filterFlightListing();
    // 			}
    //     );
    // 	}
    // },
    // getDepartures: function( date, hour, callback ){
    //   var flights = localStorage.getItem(wf.flights.airportCode + '_flights_departures')
    // 	if( wf.cookie( wf.flights.airportCode + '_updateDepartures' ) !== null && flights !== null ) {
    // 		wf.flights.departures = JSON.parse( flights );
    //     if( typeof(callback) === "function" ){
    //       callback( wf.flights.departures );
    //     }
    //     wf.terminalFilters.filterFlightListing();
    // 	} else {
    // 		$.post(
    // 			wf.flights.apiURL,
    // 			{
    // 				action: 'getFlightsByAirport',
    // 				airportCode: wf.flights.airportCode,
    // 				date: date,
    // 				hour: hour,
    // 				arrivalDeparture: 'dep',
    // 				supportedTerminals: wf.flights.supportedTerminals
    // 			},
    //       function( response ){
    // 				// Set cookie for timer, store data in localStorage
    // 				wf.cookie( wf.flights.airportCode + '_updateDepartures', '', 0.00347222 ); // Cookie for timer
    // 				localStorage.setItem(wf.flights.airportCode + '_flights_departures', JSON.stringify( response ));
    // 				wf.flights.departures = response;
    //         if( typeof(callback) === "function" ){
    //           callback( response );
    //         }
    //         wf.terminalFilters.filterFlightListing();
    // 			}
    //     );
    // 	}
    // },
    // getFlightByID: function( flightID, date, secondaryDate, arrivalDeparture, callback ){
    // 	// wf.cookie( wf.flights.airportCode + '_updateTrackedFlight', false );
    // 	wf.cookie( 'flightLookupError', false );
    // 	$(".flight-search .error").remove();
    //
    // 	if( !flightID.length ){
    // 		wf.cookie( 'flightLookupError', 1, 0.00018 );
    // 		if( window.location.pathname.match(/arriving-departing-flights/i) ){
    // 			wf.page.showFlightLookupError();
    // 			return;
    // 		} else if( arrivalDeparture === 'arr' ){
    // 			window.location = $(".primary-navigation a[href*='flights']").attr('href') + "?flightType=arrivals";
    // 		} else {
    // 			window.location = $(".primary-navigation a[href*='flights']").attr('href');
    // 		}
    //
    // 		return;
    // 	}
    //
    // 	if( wf.cookie( wf.flights.airportCode + '_updateTrackedFlight') !== null && localStorage[wf.flights.airportCode + '_trackedFlightHtml_' + flightID] !== undefined ) {
    // 		localStorage[wf.flights.airportCode + '_flights_trackedFlight'] = localStorage[wf.flights.airportCode + '_flights_trackedFlight_' + flightID];
    // 		wf.flights.trackedFlight = JSON.parse( localStorage[wf.flights.airportCode + '_flights_trackedFlight'] );
    // 		callback( wf.flights.trackedFlight );
    // 	} else if( wf.cookie( wf.flights.airportCode + '_updateTrackedFlight') !== null && flightID === localStorage[wf.flights.airportCode + '_flights_trackedFlightID'] ) {
    // 		wf.flights.trackedFlight = JSON.parse( localStorage[wf.flights.airportCode + '_flights_trackedFlight'] );
    // 		callback( wf.flights.trackedFlight );
    // 	} else {
    // 		localStorage.removeItem( wf.flights.airportCode + '_flights_trackedFlight' );
    // 		localStorage.removeItem( wf.flights.airportCode + '_flights_trackedFlightID' );
    // 		localStorage.removeItem( wf.flights.airportCode + '_flights_trackedFlightType' );
    //
    // 		$.post(
    // 			wf.flights.apiURL,
    // 			{
    // 				action: 'getFlightByID',
    // 				flightID: flightID,
    // 				date: date,
    // 				arrivalDeparture: arrivalDeparture,
    // 				airportCode: wf.flights.airportCode,
    // 				supportedTerminals: wf.flights.supportedTerminals
    // 			},
    //       function( response ){
    // 				// Set cookie for timer, store data in localStorage
    // 				if( response.flightCount !== 1 && response.queryDate === secondaryDate ){
    // 					wf.cookie( 'flightLookupError', 1, 0.00018 );
    // 					wf.page.departureArrivalRedirect();
    //
    // 					if( window.location.pathname.match(/arriving-departing-flights/i) ){
    // 						wf.page.showFlightLookupError();
    // 						return;
    // 					} else if( arrivalDeparture === 'arr' ){
    // 						window.location = $(".primary-navigation a[href*='flights']").attr('href') + "?flightType=arrivals";
    // 					} else {
    // 						window.location = $(".primary-navigation a[href*='flights']").attr('href');
    // 					}
    //
    // 					return;
    // 				} else if( response.flightCount !== 1 && response.queryDate !== secondaryDate ){
    // 					wf.flights.getFlightByID( flightID, secondaryDate, secondaryDate, arrivalDeparture, callback );
    // 					return;
    // 				}
    //
    // 				var flight = response.flights[0],
    // 						responseFlightID = flight.flightID.split(':')[0];
    //
    // 				wf.cookie( wf.flights.airportCode + '_updateTrackedFlight', '', 0.00347222 ); // Cookie for timer
    //
    // 				localStorage[wf.flights.airportCode + '_flights_trackedFlightType'] = arrivalDeparture;
    // 				localStorage[wf.flights.airportCode + '_flights_trackedFlight'] = JSON.stringify( flight );
    // 				localStorage[wf.flights.airportCode + '_flights_trackedFlight_' + responseFlightID] = JSON.stringify( flight );
    // 				localStorage[wf.flights.airportCode + '_flights_trackedFlightID'] = responseFlightID;
    // 				wf.flights.trackedFlight = response;
    //
    // 				if( callback !== undefined ){
    // 					callback( response.flights[0] );
    // 				}
    // 			}
    //     );
    // 	}
    //
    // 	if( wf.cookie( wf.flights.airportCode + '_updateTrackedFlight' ) !== null && flightID !== localStorage[wf.flights.airportCode + '_flights_trackedFlightID'] ){
    // 		localStorage[wf.flights.airportCode + '_flights_trackedFlightID'] = flightID;
    // 	}
    // },
    // loadFlightList: function(){
    // 	if( !$('.flight-list-wrapper').length ){ return; }
    //
    // 	var dateTime = $('body').data('date').toString(),
    // 			date = dateTime.substring(0, dateTime.length - 5).replace(/\//g,''),
    // 			hour = dateTime.substring(dateTime.length - 4);
    // 			date = date.replace(/\//g,'');
    //
    // 	wf.flights.getArrivals( date, hour, wf.flights.parseArrivals );
    // 	wf.flights.getDepartures( date, hour, wf.flights.parseDepartures );
    // },
    // loadJourneyPage: function(){
    // 	if( !$(".flight-details-outer-wrapper").length ){ return; }
    //
    // 	var tempFlightID = localStorage[wf.flights.airportCode + '_flights_trackedFlightID'];
    //
    // 	if( tempFlightID === undefined ){
    //     $(".flight-details-outer-wrapper").addClass('no-flight');
    //     $(".departure-arrival-details").remove();
    //     $(".journey-planner-intro--tracked-flight").remove();
    //     return;
    //   }
    //
    //   $(".journey-planner-intro").remove();
    //
    // 	if( wf.cookie( wf.flights.airportCode + '_updateJourneyTrackedFlight') !== null && tempFlightID !== undefined && localStorage[wf.flights.airportCode + '_journey_trackedFlightHtml_' + tempFlightID] !== undefined ){
    // 		$(".flight-details-outer-wrapper").html( localStorage[wf.flights.airportCode + '_journey_trackedFlightHtml_'+ tempFlightID] );
    // 		return;
    // 	}
    //
    // 	if( localStorage[wf.flights.airportCode + '_flights_trackedFlightID'] !== undefined ){
    // 		wf.flights.getFlightByID( tempFlightID, wf.flights.date, wf.flights.secondaryDate, wf.flights.arrivalDeparture, wf.flights.parseJourneyTrackedFlight );
    // 	}
    // },
    // loadTrackedFlight: function(){
    // 	if( localStorage[wf.flights.airportCode + '_trackedFlightHtml_default'] === undefined ){
    // 		localStorage[wf.flights.airportCode + '_trackedFlightHtml_default'] = $(".tracked-flight-info-wrapper").html();
    // 	}
    //
    // 	wf.page.departureArrivalRedirect();
    //
    // 	var tempFlightID = localStorage[wf.flights.airportCode + '_flights_trackedFlightID'];
    //
    // 	if( tempFlightID === undefined ){ return; }
    //
    // 	if( wf.cookie( wf.flights.airportCode + '_updateTrackedFlight') !== null && localStorage[wf.flights.airportCode + '_trackedFlightHtml_'+ tempFlightID] !== undefined ){
    // 		$("body").addClass('show-tracked-flight');
    // 		$(".tracked-flight-info-wrapper").removeClass('hidden').html( localStorage[wf.flights.airportCode + '_trackedFlightHtml_'+ tempFlightID] );
    // 		return;
    // 	}
    //
    // 	if( wf.cookie( wf.flights.airportCode + '_updateTrackedFlight') !== null && tempFlightID === $(".tracked-flight-info").data('flightID') ){ return; }
    //
    // 	$(".tracked-flight-info").removeClass('warn').removeAttr('data-flightID');
    // 	$(".tracked-flight-info-wrapper").html( localStorage[wf.flights.airportCode + '_trackedFlightHtml_default'] );
    //
    // 	if( localStorage[wf.flights.airportCode + '_flights_trackedFlightID'] !== undefined ){
    // 		wf.flights.getFlightByID( localStorage[wf.flights.airportCode + '_flights_trackedFlightID'].split(':')[0], wf.flights.date, wf.flights.secondaryDate, wf.flights.arrivalDeparture, wf.flights.parseTrackedFlight );
    // 	}
    // },
    // parseArrivals: function( flightData ){
    // 	var flights = flightData.flights,
    // 			tableData = '';
    //
    // 	flights.sort(function (a, b) {
    // 		return new Date(a.arrival.time.sort).getTime() - new Date(b.arrival.time.sort).getTime();
    // 	});
    //
    //   flights.forEach(function(flight, index) {
    //     tableData += wf.flights.formatFlightData( flight, 'arrival', index );
    //   });
    //
    // 	$("#arrivals tbody").html(tableData);
    // },
    // /**
    //  * Sample response - "2016-01-01".
    //  * Split date into year, month, and day.
    //  * Reorder, and get month as full name instead of 3 letter shortcode.
    //  */
    // parseDate: function( date ){
    // 	var monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    // 			tempDate = date.split('-'),
    // 			year = tempDate[0],
    // 			day = tempDate[2],
    // 			month = monthNames[ new Date( date ).getMonth() ];
    //
    // 	return month + " " + day + ", " + year;
    // },
    // parseDepartures: function( flightData ){
    // 	var flights = flightData.flights,
    // 			tableData = '';
    //
    // 	flights.sort(function (a, b) {
    // 		return new Date(a.departure.time.sort).getTime() - new Date(b.departure.time.sort).getTime();
    // 	});
    //
    //   flights.forEach(function(flight, index) {
    //     tableData += wf.flights.formatFlightData( flight, 'departure', index );
    //   });
    //
    // 	$("#departures tbody").html(tableData);
    // },
    // parseJourneyTrackedFlight: function( flight ){
    // 	var flightID = flight.flightID.split(':')[0],
    // 			flightNumber = flight.flightNumber,
    // 			airlineName = flight.airline || '-',
    // 			arrivalFSCode = flight.arrival.airportCode,
    // 			arrivalCity = flight.arrival.city,
    // 			departureCity = flight.departure.city,
    // 			terminal = flight.departure.terminal,
    // 			gate = flight.departure.gate,
    // 			time = flight.departure.time.scheduled.formatted,
    // 			date = flight.departure.date.formatted;
    //
    // 	if( flight.arrival.airportCode === wf.flights.airportCode ){
    // 		terminal = flight.arrival.terminal;
    // 		gate = flight.arrival.gate;
    // 		time = flight.arrival.time.scheduled.formatted;
    // 		date = flight.arrival.date.formatted;
    // 		$(".departure-arrival-details span").text('Arriving');
    // 	}
    //
    // 	$(".flight-details-wrapper .airline .label").text( airlineName );
    // 	$(".flight-details-wrapper .airline .value").text( flightNumber );
    // 	$(".flight-details-wrapper .departure-airport .label").text( departureCity );
    // 	$(".flight-details-wrapper .departure-airport .value, .journey-planner-section .departure-airport-fs-code").text( wf.flights.airportCode );
    // 	$(".flight-details-wrapper .arrival-airport .label").text( arrivalCity );
    // 	$(".flight-details-wrapper .arrival-airport .value").text( arrivalFSCode );
    // 	$(".flight-details-wrapper .departure-arrival-details strong").text( date );
    // 	$(".flight-details-wrapper .departure-gate .value, .journey-planner-section .gate").text( gate );
    // 	$(".flight-details-wrapper .departure-terminal .value, .journey-planner-section .terminal").text( terminal );
    // 	$(".flight-details-wrapper .boarding-countdown .value").text( time );
    // 	localStorage[wf.flights.airportCode + '_journey_trackedFlightHtml_' + flightID] = $(".flight-details-outer-wrapper").html();
    //
    // 	var terminalMapLink = '';
    //
    // 	if(terminal === "TBIT" ){
    // 		terminalMapLink = $(".mega-menu a[href*='/maps/tbit']").attr('href');
    // 	} else {
    // 		terminalMapLink = $(".mega-menu a[href*='/maps/terminal-"+terminal.toLowerCase()+"']").attr('href');
    // 	}
    //
    // 	$(".checking_in_at_terminal a[href*='maps']").attr('href', terminalMapLink);
    // },
    // parseTrackedFlight: function( flight, arrivalDeparture, isSuccess ){
    // 	if( arrivalDeparture === undefined ){
    // 		arrivalDeparture = wf.flights.arrivalDeparture;
    // 	}
    //
    // 	if( isSuccess === undefined ){
    // 		isSuccess = wf.flights.isSuccess;
    // 	}
    // 	// if( !isSuccess ){
    // 	// 	var flightID = flight.flightID;
    // 	// 	localStorage.removeItem( wf.flights.airportCode + '_trackedFlightHtml_'+ flightID );
    // 	// 	localStorage.removeItem( wf.flights.airportCode + '_flights_trackedFlightID' );
    // 	// 	localStorage.removeItem( wf.flights.airportCode + '_flights_trackedFlight' );
    // 	// 	$(".flight-search").prepend( flight.error.errorMessage );
    // 	// 	// wf.flights.trackedFlight = {};
    // 	// 	return;
    // 	// }
    //
    // 	var flightID = flight.flightID.split(':')[0],
    // 			arrivalFSCode = flight.arrival.airportCode,
    // 			departureFSCode = flight.departure.airportCode,
    // 			arrivalCity = flight.arrival.city,
    // 			departureCity = flight.departure.city,
    // 			gate = flight.departure.gate || '-',
    // 			time = flight.departure.time.scheduled.formatted,
    // 			status = flight.status;
    //
    // 	$(".tracked-flight-info").removeClass('warn');
    //
    // 	if( arrivalDeparture === 'arr' ){
    // 		gate = flight.arrival.gate || '-';
    // 		time = flight.arrival.time.scheduled.formatted;
    // 		$(".tracked-flight-info .boarding-countdown .label").text( 'Landing' );
    // 	}
    //
    // 	switch( status ){
    // 		case 'Delayed':
    // 			status = "warn"; break;
    // 		case 'Cancelled':
    // 			status = "warn"; break;
    // 		case 'No Status':
    // 			status = "warn"; break;
    // 		case 'Past Flight':
    // 			status = "warn"; break;
    // 		default:
    // 			status = '';
    // 	}
    //
    // 	$(".tracked-flight-info").removeClass('hidden').addClass(status).data( 'flightID', flightID );
    // 	$(".tracked-flight-info .arrival-airport .value").text( arrivalCity );
    // 	$(".tracked-flight-info .departure-airport .label").text( departureCity );
    // 	$(".tracked-flight-info .departure-airport .value").text( departureFSCode );
    // 	$(".tracked-flight-info .arrival-airport .label").text( arrivalCity );
    // 	$(".tracked-flight-info .arrival-airport .value").text( arrivalFSCode );
    // 	$(".tracked-flight-info .departure-gate .value").text( gate );
    // 	$(".tracked-flight-info .boarding-countdown .value").text( time );
    //
    // 	wf.cookie( wf.flights.airportCode + '_updateTrackedFlight', '', 0.00347222 );
    // 	localStorage[wf.flights.airportCode + '_flights_trackedFlight'] = JSON.stringify( flight );
    // 	localStorage[wf.flights.airportCode + '_flights_trackedFlight_' + flightID] = JSON.stringify( flight );
    // 	localStorage[wf.flights.airportCode + '_flights_trackedFlightID'] = flightID;
    // 	localStorage[wf.flights.airportCode + '_trackedFlightHtml_' + flightID] = $(".tracked-flight-info-wrapper").html();
    //
    // 	$("body").addClass('show-tracked-flight');
    // 	$(".tracked-flight-info-wrapper").removeClass('hidden');
    //
    //   if( $(".flight-search button img").length ){
    //     $(".flight-search button").html( wf.searchIcon );
    //     $(".flight-search input, .flight-search button").removeAttr('disabled');
    //     window.location = $(".main-menu-item a[href*='plan']").attr('href');
    //   }
    // },
    // toggleArrivalDepartures: function(){
    // 	if( !$('.flight-list-wrapper').length ){ return; }
    //
    //   if(wf.flights.arrivals === null || wf.flights.departures === null) {
    //     var callback = function() {
    //        wf.flights.toggleArrivalDepartures();
    //     };
    //
    //     setTimeout(function(){
    //       wf.flights.getFlights(callback);
    //     }, 100);
    //     return false;
    //   }
    //
    //   var flightSuggestions = [];
    //   var flights = wf.flights.departures.flights.concat(wf.flights.arrivals.flights);
    //
    //   var hash = window.location.search;
    // 	if( hash.indexOf('flightType') > -1 ){
    //     var flightType = hash.split('flightType=')[1].replace(/\W/ig, '');
    //
    // 		if( flightType.length && flightType === "arrivals" || flightType === "departures" ){
    // 			$(".flights-nav a, .flight-list").removeClass('active');
    // 			$(".flights-nav a[href=#" + flightType + "], .flight-list#" + flightType).addClass('active');
    // 		} else {
    // 			$(".flights-nav li:last a, .flight-list:last").addClass('active');
    // 		}
    // 	}
    //
    //   if(hash.indexOf('airlineCode') > -1) {
    //     var airlineCode = hash.split('airlineCode=')[1].split('&')[0].toUpperCase();
    //     $(".flight-list").addClass('airline-filter-active');
    //     $(".flight-list tr[data-flight-airlinecode='" + airlineCode + "']").addClass('selected-airline');
    //
    //     var airline = null;
    //
    //     flights.forEach(function(flight) {
    //       if(airline !== null) {
    //         return false;
    //       }
    //
    //       var flightId = flight.flightID.split(':')[0];
    //       if(flightId.indexOf(airlineCode) > -1) {
    //         airline = flight.airline;
    //       }
    //     });
    //
    //     if(!$('.airline-filter').length) {
    //       $(".flight-list").prepend('<div class="airline-filter">Showing results for <a href="#">' + airline + '</a></div>');
    //     }
    //   }
    //
    //   $(".airline-filter a").on('click', function(e) {
    //     e.preventDefault();
    //     $(".airline-filter").remove();
    //     $(".flight-list").removeClass('airline-filter-active');
    //     $(".flight-list tr").removeClass('selected-airline');
    //   });
    //
    // 	var toggleEvent = ("ontouchend" in document) ? 'touchstart' : 'click';
    // 	$(".flights-nav a").on(toggleEvent, function(e){
    // 		e.preventDefault();
    //
    // 		if( $(this).hasClass('active') ){ return; }
    //
    // 		var hash = $(this).attr('href');
    // 		$(".flights-nav a, .flight-list").removeClass('active');
    // 		$(".flights-nav a[href=" + hash + "], .flight-list" + hash).addClass('active');
    //
    // 		if( hash === '#arrivals' ){
    // 			wf.flights.arrivalDeparture = 'arr';
    // 		} else {
    // 			wf.flights.arrivalDeparture = 'dep';
    // 		}
    // 	});
    // },
    // trackFlightFromList: function(){
    // 	if( !$('.flight-list-wrapper').length ){ return; }
    // 	var toggleEvent = ("ontouchend" in document) ? 'touchend' : 'click';
    // 	$(document).on(toggleEvent, 'tr[data-flight-index]', function(){
    // 		if( dragged ){ return; }
    //
    // 		$(".flight-list tr").removeClass('tracked-flight');
    // 		$(this).addClass('tracked-flight');
    //
    // 		var arrivalDeparture, flight, isSuccess, flightIndex = $(this).data('flight-index');
    // 		if( $(".flights-nav a[href='#arrivals'].active").length ){
    // 			arrivalDeparture = localStorage[wf.flights.airportCode + '_flights_trackedFlightType'] = 'arr';
    // 			flight = wf.flights.arrivals.flights[flightIndex];
    // 			isSuccess = wf.flights.arrivals.isSuccess;
    // 		} else {
    // 			arrivalDeparture = localStorage[wf.flights.airportCode + '_flights_trackedFlightType'] = 'dep';
    // 			flight = wf.flights.departures.flights[flightIndex];
    // 			isSuccess = wf.flights.departures.isSuccess;
    // 		}
    //
    // 		wf.flights.parseTrackedFlight( flight, arrivalDeparture, isSuccess );
    // 		wf.flights.loadTrackedFlight();
    //
    // 		wf.page.departureArrivalRedirect();
    // 	});
    // }
  },
  loadJS: function(src, cb) {
    'use strict';
    var ref = window.document.getElementsByTagName('script')[0];
    var script = window.document.createElement('script');
    script.src = src;
    script.async = true;
    ref.parentNode.insertBefore(script, ref);
    if (cb && typeof cb === 'function') {
      script.onload = cb;
    }
    return script;
  },
  navigation: {
    init: function() {
      wf.navigation.megaMenuSetup();
      wf.navigation.toggleMegaNav();
      // wf.navigation.retailerCategories();
      // wf.navigation.shrinkHeaderNav();
    },
    megaMenuSetup: function() {
      $('.mega-menu .sub-menu').each(function() {
        $(this).css('max-height', $(this).outerHeight());
      });

      $('body').addClass('mega-menu-setup');
    },
    // retailerCategories: function(){
    //   Array.from( document.querySelectorAll( 'select.cs-select' ) ).forEach( function(el) {
    //     new SelectFx(el, { newTab: false });
    //   });
    //
    // 	$("body:not(.search) .retailer-categories select").change(function(){
    // 		window.location = $(this).val();
    // 	});
    // },
    toggleMegaNav: function() {
      $('.mega-nav-toggle, .mega-menu .close-modal').on('click', function(e) {
        e.preventDefault();
        $('body')
          .toggleClass('mega-nav-active')
          .removeClass('search-overlay-active');
      });
    },
    shrinkHeaderNav: function() {
      $(window).scroll(function() {
        if ($(window).scrollTop() > 0) {
          $('body:not(.terminal-map),body:not(.home)').addClass('small-header');
        } else {
          $('body:not(.terminal-map)').removeClass('small-header');
        }
      });
    },
  },
  page: {
    init: function() {
      wf.page.backLink();
      wf.page.departureArrivalRedirect();
      wf.page.locationBasedSlides();
      wf.page.retailerSearchFilters();
      wf.page.showFlightLookupError();
      wf.page.showMapSearch();
      wf.page.mobileMapZoom();
      wf.page.triggerEventSlider();
      wf.page.triggerShopSlider();
      wf.page.showHideContentToggle();
      wf.page.showHideSetup();
      wf.page.scrollToSection();
      wf.page.megaNavLinks();
      wf.page.hideOverlay();
      wf.page.directoryFiltersToggle();
      wf.page.activeMobileFilters();
      wf.page.bannerSlider();
      wf.page.closeGrabPromo();
    },
    bannerSlider: function() {
      if ($('.banner-slide').length < 2) {
        return;
      }
      $('.banner-slider').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        pauseOnHover: false,
        fade: true,
      });
    },
    backLink: function() {
      var toggleEvent = 'ontouchend' in document ? 'touchstart' : 'click';
      $('.close-modal.back-link').on(toggleEvent, function(e) {
        e.preventDefault();
        window.history.back();
      });
    },
    departureArrivalRedirect: function() {
      // var link = '', href = '';
      // if( $(".primary-navigation .modified-link").length ){
      // 	link = $(".primary-navigation .modified-link");
      // 	href = link.attr('href').replace(/departure-details\/|arrival-details\//,'');
      // 	link.attr('href', href).removeClass('modified-link');
      // }
      //
      // if( localStorage[wf.flights.airportCode + '_flights_trackedFlightType'] === undefined ){ return; }
      //
      // if( localStorage[wf.flights.airportCode + '_flights_trackedFlightType'] === 'dep' ){
      // 	link = $(".primary-navigation a[href$='plan/']");
      // 	href = link.attr('href') + 'departure-details/';
      // 	link.attr('href', href).addClass('modified-link');
      // } else if( localStorage[wf.flights.airportCode + '_flights_trackedFlightType'] === 'arr' ){
      // 	link = $(".primary-navigation a[href$='arrive/']");
      // 	href = link.attr('href') + 'arrival-details/';
      // 	link.attr('href', href).addClass('modified-link');
      // }
    },
    locationBasedSlides: function() {
      if (!$('.flight-details-wrapper').length) {
        return;
      }

      var apiURLBase = wf_api.url;
      var retailersAPI = apiURLBase + '/retailers?per_page=100';
      var flight = null;
      var flightType = null;
      var terminal = null;
      var gate = null;

      if (localStorage[wf.flights.airportCode + '_flights_trackedFlightID']) {
        flight = JSON.parse(
          localStorage[wf.flights.airportCode + '_flights_trackedFlight']
        );
        flightType =
          localStorage[wf.flights.airportCode + '_flights_trackedFlightType'];
        terminal = flight.departure.terminal;
        gate = flight.departure.gate;
      }

      if (flightType === 'arr') {
        terminal = flight.arrival.terminal;
        gate = flight.arrival.gate;
      }

      if (gate === null) {
        $('.near-gate-slides')
          .parent('.journey-slider-wrapper')
          .remove();
        $('.departure_terminal_details .more-links').remove();
      }

      var terminalID = null;
      if (terminal !== null) {
        var terminalSlug = '';
        if (terminal.toLowerCase() === 'tbit') {
          terminalSlug = 'tom-bradley-international-terminal';
        } else {
          terminalSlug = 'terminal-' + terminal.toLowerCase();
        }

        $.ajax({
          url: apiURLBase + '/terminals?slug=' + terminalSlug,
          method: 'GET',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('X-WP-Nonce', wf_api.nonce);
          },
        }).done(function(terminal) {
          if (terminal.length) {
            terminalID = terminal[0].id;
          }

          wf.page.getRetailers(
            retailersAPI,
            terminalID,
            wf.page.filterRetailerSlides
          );
          wf.page.getGateRetailers(apiURLBase, gate, terminalID, retailersAPI);
        });
      } else {
        wf.page.getRetailers(
          retailersAPI,
          terminalID,
          wf.page.filterRetailerSlides
        );
      }
    },
    getGateRetailers: function(apiURLBase, gate, parentTerminal, retailersAPI) {
      var gateID = null;
      $.ajax({
        url:
          apiURLBase +
          '/terminals?slug=' +
          gate.toLowerCase() +
          '&parent=' +
          parentTerminal,
        method: 'GET',
        beforeSend: function(xhr) {
          xhr.setRequestHeader('X-WP-Nonce', wf_api.nonce);
        },
      }).done(function(gate) {
        if (gate.length) {
          gateID = gate[0].id;
        }

        wf.page.getRetailers(retailersAPI, gateID, wf.page.filterGateSlides);
      });
    },
    filterGateSlides: function(gateRetailers) {
      var nearGate = [];

      gateRetailers.forEach(function(retailer) {
        if (retailer.has_near_gate_slides) {
          nearGate.push(retailer);
        }
      });

      if (nearGate.length) {
        $('.near-gate-slides').html(
          wf.page.formatSlides(nearGate, 'near_gate')
        );
        wf.page.triggerJourneySlider($('.near-gate-slides'));
      } else {
        $('.near-gate-slides')
          .parent('.journey-slider-wrapper')
          .remove();
        $('.departure_terminal_details .more-links').remove();
      }
    },
    getRetailers: function(apiURL, terminalID, callback) {
      var retailerURL = terminalID
        ? apiURL + '&terminals=' + terminalID
        : apiURL;
      var retailers = [];
      $.ajax({
        url: retailerURL,
        method: 'GET',
        beforeSend: function(xhr) {
          xhr.setRequestHeader('X-WP-Nonce', wf_api.nonce);
        },
      }).done(function(results, textStatus, request) {
        if (!results.length) {
          return false;
        }

        retailers.push(results);

        var pageCount = request.getResponseHeader('X-WP-TotalPages');

        if (pageCount > 1) {
          for (var currentPage = 2; currentPage <= pageCount; currentPage++) {
            $.ajax({
              url: retailerURL + '&page=' + currentPage,
              method: 'GET',
              beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', wf_api.nonce);
              },
            }).done(function(pagedResults) {
              retailers.push(pagedResults);
            });
          }
          callback(results);
        } else {
          callback(results);
        }
      });
    },
    filterRetailerSlides: function(retailers) {
      var beforeYouCheckIn = [],
        shopping = [],
        dining = [],
        other = [];
      var has_retailer_slides = false;

      retailers.forEach(function(retailer) {
        if (!retailer.has_retailer_slides) {
          return;
        }

        has_retailer_slides = true;

        if (retailer.has_before_you_check_in_slides) {
          beforeYouCheckIn.push(retailer);
        }

        if (retailer.has_shopping_slides) {
          shopping.push(retailer);
        }

        if (retailer.has_dining_slides) {
          dining.push(retailer);
        }

        if (retailer.has_other_slides) {
          other.push(retailer);
        }
      });

      if (!has_retailer_slides) {
        $('.journey-planner-section.discover_more').remove();
        $('.journey-slider-wrapper').remove();
      }

      if (beforeYouCheckIn.length) {
        $('.before-you-check-in-slides').html(
          wf.page.formatSlides(beforeYouCheckIn, 'before_you_check_in')
        );
        wf.page.triggerJourneySlider($('.before-you-check-in-slides'));
      } else {
        $('.before-you-check-in-slides')
          .parent('.journey-slider-wrapper')
          .remove();
      }

      if (shopping.length) {
        $('.shopping-slides').html(wf.page.formatSlides(shopping, 'shopping'));
        wf.page.triggerJourneySlider($('.shopping-slides'));
      } else {
        $('.shopping-slides')
          .parent('.journey-slider-wrapper')
          .remove();
      }

      if (dining.length) {
        $('.dining-slides').html(wf.page.formatSlides(dining, 'dining'));
        wf.page.triggerJourneySlider($('.dining-slides'));
      } else {
        $('.dining-slides')
          .parent('.journey-slider-wrapper')
          .remove();
      }

      if (other.length) {
        $('.other-slides').html(wf.page.formatSlides(other, 'other'));
        wf.page.triggerJourneySlider($('.other-slides'));
      } else {
        $('.other-slides')
          .parent('.journey-slider-wrapper')
          .remove();
      }
    },
    retailerSearchFilters: function() {
      if (!$('.search-results .retailer-categories').length) {
        return;
      }

      if ($('.retailer-categories:first option:selected').data('id') !== '') {
        var id = $('.retailer-categories:first option:selected').data('id');
        wf.page.retailerSearchFilterOptions(id);
      }

      $('.retailer-categories:first select').change(function() {
        var id = $('.retailer-categories:first option:selected').data('id');
        wf.page.retailerSearchFilterOptions(id);
      });

      $('.retailer-categories select').change(function() {
        $('.retailers').removeClass('category-filter-active');
        $('.retailer').removeClass('category-hidden');

        if ($(this).val() !== '') {
          $('.retailers').addClass('category-filter-active');
          $('.retailer:not(.' + $(this).val() + ')').addClass(
            'category-hidden'
          );
        }
      });
    },
    retailerSearchFilterOptions: function(id) {
      var options =
        '<option value="' +
        $('.retailer-categories:first option:selected').val() +
        '">All</option>';
      if (id !== undefined) {
        var current = searchCategories[id];

        for (var i = 0; i < current.length; i++) {
          var data = current[i].split('::');
          options += '<option value="' + data[0] + '">' + data[1] + '</option>';
        }
      }

      $('.retailer-categories:last select').html(options);
    },
    formatSlides: function(slides, category) {
      if (slides.length === 0) {
        return;
      }
      var formattedSlides = '';

      slides.forEach(function(slide) {
        var title = slide.title.rendered;
        var link = slide.link;
        var slideImage = slide.retailer_slides[category].slide_image;
        var slideText = slide.retailer_slides[category].slide_text;

        formattedSlides +=
          '<article class="retailer-slide"><a href="' +
          link +
          '"><img src="' +
          slideImage +
          '"><h6>' +
          title +
          '</h6><p>' +
          slideText +
          '</p></a></article>';
      });

      return formattedSlides;
    },
    showFlightLookupError: function() {
      if (wf.cookie('flightLookupError') === null) {
        return;
      }
      $('.flight-search')
        .find('button')
        .html(wf.searchIcon);
      $('.flight-search')
        .find('input,button')
        .prop('disabled', false);
      $('.flight-search').prepend(
        '<div class="error">Sorry, no flight could be found within 48 hours matching your flight number.'
      );
      $('.flight-search .error').css(
        'max-height',
        $('.flight-search .error').height()
      );

      setTimeout(function() {
        $('.flight-search .error').addClass('hide');
      }, 5000);

      wf.cookie('flightLookupError', false);
    },
    showMapSearch: function() {
      $('.toggle-map-search').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('show-map-search');
      });

      $(document).on('click', '.mapplic-list a', function(e) {
        if (window.innerWidth >= 640 || dragged) {
          return;
        }
        e.preventDefault();
        $('body').removeClass('show-map-search');
      });
    },
    mobileMapZoom: function() {
      var map = $('.mapplic-element');
      if (window.innerWidth > 960 || !map.length) {
        return false;
      }

      var self = $('.mapplic-element').data('mapplic');

      if (self && self.x === 0) {
        $('.mapplic-zoomin-button')
          .trigger('click')
          .trigger('click');
      }
    },
    triggerEventSlider: function() {
      if (!$('.event-slides').length) {
        return;
      }
      $('.event-slides').slick({
        autoplaySpeed: 6000,
        dots: true,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });
    },
    triggerJourneySlider: function(element) {
      if (!element.length) {
        return;
      }
      element.slick({
        autoplaySpeed: 6000,
        dots: true,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      });
    },
    triggerShopSlider: function() {
      if (!$('.retailer-slides').length) {
        return;
      }
      $('.retailer-slides').slick({
        autoplaySpeed: 6000,
        dots: true,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });
    },
    showHideContentToggle: function() {
      $('.show-hide-title').on('click', function(e) {
        e.preventDefault();
        $(this)
          .parent('.show-hide-section')
          .toggleClass('active');
      });
    },
    showHideSetup: function() {
      $('.show-hide-content').each(function() {
        $(this).css('max-height', $(this).outerHeight());
      });

      wf.page.scrollToSection();
      $('body').addClass('show-hide-setup');
    },
    scrollToSection: function(sectionHash) {
      var hash = sectionHash || window.location.hash;
      if (hash.length && $(hash).length) {
        $('html, body').animate(
          {
            scrollTop: $(hash).offset().top - $('header').outerHeight() - 16,
          },
          100
        );

        if ($(hash).hasClass('show-hide-section')) {
          $(hash).addClass('active');
        }
      }
    },
    megaNavLinks: function() {
      var currentPage = window.location.pathname;
      $('.mega-menu a').on('click', function() {
        var href = $(this).attr('href');
        if (href.indexOf(currentPage) > -1) {
          var hash = href.split('#')[1];
          $('body').removeClass('mega-nav-active');
          wf.page.scrollToSection('#' + hash);
        }
      });
    },
    hideOverlay: function() {
      $('.nav-content-overlay').on('click', function(e) {
        e.preventDefault();
        $('body').removeClass('search-overlay-active mega-nav-active');
      });
    },
    directoryFiltersToggle: function() {
      $(
        '.directory-filter-toggle, .directory__filters .close-modal, .directory-filter--active-terminal, .directory__items__meta u'
      ).on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('directory-filters-visible');
        $('.directory__filters').toggleClass('directory__filters--visible');
      });
    },
    activeMobileFilters: function() {
      var activeTerminal = $('.directory__filters__filter--terminals .active a')
        .text()
        .trim();
      var viewAll = $('.directory__filters__filter--terminals li:first a')
        .text()
        .trim();
      if (activeTerminal === viewAll) {
        $('.directory-filter-toggle-wrapper .order-filter-toggle-terminal')
            .html('All Terminals ');
        return false
      }

      $('.directory-filter-toggle-wrapper .order-filter-toggle-terminal')
        .html('Terminal ' + activeTerminal);
    },
    closeGrabPromo: function() {
      var showPromo = wf.cookie(wf.flights.airportCode + '_show-grab-promo');
      if (showPromo === 0) {
        return false;
      }
      $('.grab-sticky-badge').removeClass('grab-sticky-badge--hidden');

      $('.grab-sticky-badge__close').on('click', function(e) {
        e.preventDefault();
        wf.cookie(wf.flights.airportCode + '_show-grab-badge', 0, 1);
        $('.grab-sticky-badge').addClass('grab-sticky-badge--hidden');
      });
    },
  },
  search: {
    init: function() {
      wf.search.toggleSearchOverlay();
      wf.search.ajaxSearch();
      // wf.search.selectFlightFromAjaxSearch();
      wf.search.toggleVisibleResults();
      // wf.search.loadFlights();
    },
    // loadFlights: function() {
    //   if( !$(".search-results-filter a[href='#flights']").length) {
    //     return false;
    //   }
    //
    //   if(wf.flights.arrivals === null || wf.flights.departures === null) {
    //     var callback = function() {
    //       wf.search.loadFlights();
    //     };
    //
    //     setTimeout(function(){
    //       wf.flights.getFlights(callback);
    //     }, 100);
    //   }
    //
    //   $(".search-results-filter a[href='#flights']").on('click touchend', function(e) {
    //     e.preventDefault();
    //
    //     $(".search-results--flights").html(wf.loadingIcon);
    //
    //     var query = $('.search-results-wrapper .search-field').val();
    //     var flightSuggestions = wf.flights.getFlightSuggestions(query);
    //
    //     var noResults = '<p class="no-results">No results found for ';
    //     noResults += query + ' in the selected terminal(s). Please search again or click here ';
    //     noResults += 'to <a href="' + window.directory_url + '">explore the directory</a></p>';
    //
    //     var results = '';
    //     if(flightSuggestions.length) {
    //       var result = (flightSuggestions.length === 1) ? 'result' : 'results';
    //       results += '<p>' + flightSuggestions.length + ' ' + result + ' found</p>';
    //     } else {
    //       results += noResults;
    //     }
    //
    //     var flightsNavItem = $(".primary-navigation a").filter(function() { return $(this).find('.menu-item__title').text() === "Flights"; });
    //
    //     flightSuggestions.forEach(function(flight) {
    //       var isDeparture = flight.flightID.split(':')[1] === wf.flights.airportCode;
    //       var flightNumber = flight.flightNumber;
    //       var flightId = flight.flightID.split(':')[0];
    //       var airlineCode = flightId.split(flightNumber)[0];
    //       var flightTerminal = isDeparture ? flight.departure.terminal : flight.arrival.terminal;
    //
    //       var terminal = 'terminal-' + flightTerminal;
    //       if(flightTerminal === 'tbit') {
    //         terminal = 'tom-bradley-international-terminal';
    //       } else if(flightTerminal === undefined) {
    //         terminal = '';
    //       }
    //
    //       var flightsUrl = flightsNavItem && flightsNavItem[0].href + "?airlineCode=" + airlineCode + "&flightType=";
    //       flightsUrl += isDeparture ? "departures" : "arrivals";
    //
    //       if(flight.suggestionType === 'airline') {
    //         terminal += ' selected-terminal always-visible';
    //         results += '<article class="search-result ' + terminal + '">';
    //       } else {
    //         terminal += ' suggested-flight';
    //         results += '<article class="search-result ' + terminal + '" data-flight-id="' + flightId + '">';
    //       }
    //
    //       if(flight.suggestionType === 'airline') {
    //         results += '<a href="' + flightsUrl + '">';
    //       } else {
    //         results += '<a href="' + flightsUrl + '">';
    //       }
    //
    //       if(flight.suggestionType === 'airline') {
    //         results += '<h1>' + flight.airline + '</h1>';
    //       } else {
    //         results += '<h1>' + flight.airline + ' #' + flight.flightNumber + '</h1>';
    //       }
    //
    //       if(flight.suggestionType === 'airline') {
    //         results += '<h2>Departures/Arrivals<span></h2>';
    //       } else {
    //         results += '<h2><strong>' + flight.departure.airportCode + ' ￫ ' + flight.arrival.airportCode + '</strong><span>';
    //         if(flightTerminal === 'TBIT') {
    //           results += 'Tom Bradley International';
    //         } else if(flightTerminal !== undefined) {
    //           results += 'Terminal ' + flightTerminal;
    //         }
    //
    //         if(isDeparture && flight.departure.gate.length) {
    //           results += ", Gate " + flight.departure.gate;
    //         } else if(!isDeparture && flight.arrival.gate.length) {
    //           results += ", Gate " + flight.arrival.gate;
    //         }
    //
    //         results += '</span><span>';
    //
    //         if(isDeparture) {
    //           results += 'Departing ' + flight.departure.time.scheduled.formatted;
    //         } else {
    //           results += 'Arriving ' + flight.arrival.time.scheduled.formatted;
    //         }
    //
    //         results += '</span></h2>';
    //       }
    //       results += '</a></article>';
    //     });
    //
    //     $(".search-results--flights").html(results);
    //   })
    // },
    toggleVisibleResults: function() {
      $('.search-results-filter').on(
        'touchend click',
        'a:not(.active)',
        function() {
          $('.search-results-filter a').removeClass('active');
          $('.search-results').removeClass('search-results--active');
          $(this).addClass('active');
          $(
            '.search-results--' +
              $(this)
                .attr('href')
                .split('#')[1]
          ).addClass('search-results--active');
        }
      );
    },
    // selectFlightFromAjaxSearch: function() {
    //   $(document).on('touchend click', '.suggested-flight', function(e){
    //     e.preventDefault();
    //     $(this).addClass('loading');
    //     var flightID = $(this).data('flight-id');
    //     var redirect = function() {
    //       window.location.replace($(".primary-navigation a[href*='airport-transportation']").attr('href'));
    //     };
    //
    //     wf.flights.getFlightByID( flightID, wf.flights.date, wf.flights.secondaryDate, wf.flights.arrivalDeparture, redirect);
    //   });
    // },
    toggleSearchOverlay: function() {
      $('body:not(.search) .search-toggle').on('click', function(e) {
        e.preventDefault();
        $('body')
          .toggleClass('search-overlay-active')
          .removeClass('mega-nav-active');
        setTimeout(function() {
          $('.search-field').focus();
        }, 200);
      });

      $('body:not(.search) .search-overlay .close-modal').on('click', function(
        e
      ) {
        e.preventDefault();
        $('body')
          .toggleClass('search-overlay-active')
          .removeClass('mega-nav-active');
      });

      $('.search .search-toggle').on('click', function(e) {
        e.preventDefault();
        $('main .search-field').focus();
      });
    },
    getSearchResults: function(query) {
      if (query.length > 2) {
        $('.search-overlay__results').removeClass(
          'search-overlay__results--hidden'
        );
      } else {
        $(
          '.search-overlay__results:not(.search-overlay__results--hidden)'
        ).addClass('search-overlay__results--hidden');
        return false;
      }

      var results = '';
      var noResults = '';

      var terminals = wf.terminalFilters.getSelectedTerminal();

      noResults += '<p class="no-results">No results found for ';
      noResults +=
        query +
        ' in the selected terminal(s). Please search again or click here ';
      noResults +=
        'to <a href="' +
        window.directory_url +
        '">explore the directory</a></p>';

      jQuery.getJSON(
        window.ajax_url,
        { action: 'load_search_results', query: query },
        function(response) {
          // if (response['products'].length) {
          //   results += "<div class='retailer-products'>";
          //   results += '<h2>Featured Items</h2>';
          //   results += "<div class='retailer-products__wrapper'>";
          // }
          //
          // response['products'].forEach(function(product) {
          //   results += "<div class='retailer-product'>";
          //   results += "<a href='" + product.url + "'>";
          //   results += product.thumb;
          //   results += product.title;
          //   results += '</a>';
          //   results += '</div>';
          // });
          //
          // if (response['products'].length) {
          //   results += '</div></div>';
          // }

          if (response['retailers'].length) {
            results += "<div class='retailer-search-wrapper'>";
            // results += '<h2>In the Airport</h2>';
          }

          response['retailers'].forEach(function(retailer) {
            if (retailer.terminal && retailer.terminal.length) {
              var retailerTerminal = retailer.terminal
                .toLowerCase()
                .replace(/\s/g, '-');
              if (terminals.indexOf(retailerTerminal) > -1) {
                retailerTerminal += ' selected-terminal';
              }
              results +=
                '<div class="search-result search-result--retailer ' +
                retailerTerminal +
                '">';
            } else {
              results +=
                '<div class="search-result search-result--retailer always-visible">';
            }

            results += '<a href="' + retailer.url + '">';
            results += '<img src="' + retailer.thumb + '" />';
            results += '<h2>' + retailer.title + '</h2>';
            if (retailer.terminal) {
              results +=
                '<h4><strong>' +
                retailer.terminal +
                '</strong> - ' +
                retailer.location +
                '</h4>';
            }
            results += '</a></div>';
          });

          if (response['retailers'].length) {
            results += '</div>';
          }

          if (!results.length) {
            results = noResults;
          } else {
            results +=
              '<div class="search-results__view-more"><button>View more results</button></div>';
          }
          $('.search-overlay__results')
            .html(results)
            .removeClass('search-overlay__results--hidden');
          $(document).on('click', '.search-results__view-more', function(e) {
            e.preventDefault();
            $('header .search-form').submit();
          });

          wf.terminalFilters.filterSearchResults();
        },
        'json'
      );
    },
    ajaxSearch: function() {
      var timeoutID = 0;

      jQuery(document).on(
        'keyup keypress keydown',
        'header .search-form input',
        function(e) {
          var query = e.target.value;

          // TODO - return if key not a-z0-9

          if (query.length > 2) {
            clearTimeout(timeoutID);
            timeoutID = setTimeout(function() {
              wf.search.getSearchResults(query);
            }, 500);
          }
        }
      );
    },
  },
  terminalFilters: {
    init: function() {
      wf.terminalFilters.setSelectedTerminal();
      wf.terminalFilters.preSecurityFilter();
      wf.terminalFilters.filterDirectoryListing();
      wf.terminalFilters.filterSearchResults();
      wf.terminalFilters.filterByURL();
      wf.terminalFilters.clearSelectedTerminal();
    },
    filterByURL: function() {
      var terminal = getUrlParameter('terminal');
      var preSecurity = getUrlParameter('pre-security');
      var postSecurity = getUrlParameter('post-security');

      if (!terminal && !preSecurity && !postSecurity) {
        return false;
      }

      if (terminal) {
        switch (true) {
          case terminal.toLocaleLowerCase() == 'tbit':
            terminal = 'tom-bradley-international-terminal';
            break;
          case Number.isFinite(parseInt(terminal)):
            terminal = 'terminal-' + terminal;
            break;
          default:
            terminal = 'all';
        }

        $('.terminal-filter li.active').removeClass('active');
        $('.terminal-filter a[href="#' + terminal + '"]')
          .parent()
          .addClass('active');

        wf.cookie(wf.flights.airportCode + '_terminal-filter', terminal, 30);
      }

      if (!terminal) {
        wf.cookie(wf.flights.airportCode + '_terminal-filter', 'all', 30);
      }

      var isPreSecurity = preSecurity == 1 ? true : false;
      var isPostSecurity = postSecurity == 1 ? true : false;

      if (isPreSecurity || isPostSecurity) {
        if (isPreSecurity && isPostSecurity) {
          console.error(
            'Cannot set pre-security and post-security query parameters to true.'
          );
          return false;
        }

        wf.cookie(
          wf.flights.airportCode + '_pre-security-filter',
          isPreSecurity,
          30
        );

        wf.cookie(
          wf.flights.airportCode + '_post-security-filter',
          isPostSecurity,
          30
        );
      }

      wf.terminalFilters.filterDirectoryListing();
      wf.terminalFilters.filterSearchResults();
      wf.page.activeMobileFilters();
      return;
    },
    getSelectedTerminal: function() {
      var storedTerminal = wf.cookie(
        wf.flights.airportCode + '_terminal-filter'
      );
      return storedTerminal ? storedTerminal : 'all';
    },
    getPreSecurityFilter: function() {
      var preSecurity = wf.cookie(
        wf.flights.airportCode + '_pre-security-filter'
      );
      return preSecurity ? preSecurity : false;
    },
    getPostSecurityFilter: function() {
      var postSecurity = wf.cookie(
        wf.flights.airportCode + '_post-security-filter'
      );
      return postSecurity ? postSecurity : false;
    },
    clearSelectedTerminal: function() {
      $('.directory__no-results a').on('click', function(e) {
        e.preventDefault();
        $('.terminal-filter li.active').removeClass('active');
        wf.cookie(wf.flights.airportCode + '_terminal-filter', 'all', 30);
        wf.cookie(wf.flights.airportCode + '_pre-security-filter', false);
        wf.cookie(wf.flights.airportCode + '_post-security-filter', false);

        $('.terminal-filter a[href="#all"]')
          .parent()
          .addClass('active');

        wf.terminalFilters.filterDirectoryListing();
        wf.terminalFilters.filterSearchResults();
        wf.page.activeMobileFilters();
      });
    },
    setSelectedTerminal: function() {
      $('.terminal-filter a').on('click', function(e) {
        e.preventDefault();

        if($(this).hasClass('terminal-redirect')){
          window.location.replace($(this).attr('href'));
        }

        if (
          $(this)
            .parent()
            .hasClass('active')
        ) {
          return false;
        }

        $('.terminal-filter li.active').removeClass('active');
        $(this)
          .parent()
          .addClass('active');
        wf.cookie(
          wf.flights.airportCode + '_terminal-filter',
          $(this)
            .attr('href')
            .split('#')[1],
          30
        );

        wf.terminalFilters.filterDirectoryListing();
        wf.terminalFilters.filterSearchResults();
        wf.page.activeMobileFilters();
      });
    },
    preSecurityFilter: function() {
      $('.pre-security-only input').on('change', function() {
        var checked = $(this).prop('checked');

        wf.cookie(wf.flights.airportCode + '_pre-security-filter', checked, 30);
        wf.cookie(wf.flights.airportCode + '_post-security-filter', false);

        wf.terminalFilters.filterDirectoryListing();
        wf.terminalFilters.filterSearchResults();
        wf.page.activeMobileFilters();
      });

      $('.pre-security-badge').on('click', function() {
        wf.cookie(wf.flights.airportCode + '_post-security-filter', false);

        if ($('.pre-security-only input').is('checked')) {
          return false;
        }

        wf.cookie(wf.flights.airportCode + '_pre-security-filter', true, 30);

        wf.terminalFilters.filterDirectoryListing();
        wf.terminalFilters.filterSearchResults();
        wf.page.activeMobileFilters();
      });
    },
    setFilteredDirectoryCount: function(terminalSlug, location) {
      window.postCount = window.postCount || {};
      var postCount = window.postCount;

      if (postCount[terminalSlug]) {
        return wf.terminalFilters.setDirectoryItemCount(
          postCount[terminalSlug]
        );
      }

      wf.terminalFilters.setDirectoryItemCount();

      var args = { action: 'get_directory_filter_count' };
      if (terminalSlug) {
        args['terminal_slug'] = terminalSlug;
      }
        args['location'] = location;

      jQuery.getJSON(window.ajax_url, args, function(response) {
        window.postCount = Object.assign(window.postCount, response);
        wf.terminalFilters.setDirectoryItemCount(response[terminalSlug]);
      });
    },
    setDirectoryItemCount(itemCount) {
      var preSecurity = wf.terminalFilters.getPreSecurityFilter();
      var postSecurity = wf.terminalFilters.getPostSecurityFilter();
      var showCount = 0;
      $(
        '.directory__filters__filter:not(.directory__filters__filter--terminals) li'
      ).each(function() {
        var slug = $(this).data('slug');
        var count = '...';
        if (itemCount) {
          count = itemCount[slug] || 0;
          var preSecurityCount = itemCount[slug + '-pre-security'] || 0;

          if (preSecurity) {
            count = preSecurityCount;
          }

          if (postSecurity) {
            count = count - preSecurityCount;
          }
        }

        $(this)
          .find('span')
          .text(count);

        if ($(this).hasClass('show-more-shops') && showCount > 7){
          showCount = 0;
        } else if (count == 0 || showCount > 7) {
          $(this).addClass('filter-item-hidden');
        } else {
          $(this).removeClass('filter-item-hidden');
          showCount++;
        }
      });
    },
    filterDirectoryListing: function() {
      if (!$('.directory').length || $('.directory--products').length) {
        return false;
      }

      var location =  $('.employee-offers__filters').length ? 'employee-offers' : 'directory';

      $('.directory').removeClass('directory--filtered');
      $('.directory .directory__item').removeClass('directory__item--visible');

      var terminal = wf.terminalFilters.getSelectedTerminal();
      var preSecurity = wf.terminalFilters.getPreSecurityFilter();
      var postSecurity = wf.terminalFilters.getPostSecurityFilter();

      $('.terminal-filter li.active').removeClass('active');
      $('.terminal-filter a[href="#' + terminal + '"]')
        .parent()
        .addClass('active');

      $('.pre-security-only input').prop('checked', preSecurity);

      // Set count for each filter
      wf.terminalFilters.setFilteredDirectoryCount(terminal, location);

      var filterClasses = '';
      if (terminal !== 'all' || preSecurity || postSecurity) {
        $('.directory').addClass('directory--filtered');

        if (terminal !== 'all') {
          filterClasses += '.' + terminal;
        }

        // if (preSecurity && postSecuirty) {
        if ( $( ".retailer-categories" ).length === 0) {
          if (preSecurity) {
            filterClasses += '.is-pre-security';
          }

          if (postSecurity) {
            filterClasses += ':not(.is-pre-security)';
          }
        }

        $('.directory .directory__item' + filterClasses).addClass(
          'directory__item--visible'
        );

        $('.result-count').text($('.directory__item--visible').length);
      } else {
        $('.result-count').text($('.directory__item').length);
      }

      if (!$('.directory .directory__item' + filterClasses).length) {
        $('.directory__no-results').removeClass(
          'directory__no-results--hidden'
        );
      } else {
        $('.directory__no-results').addClass('directory__no-results--hidden');
      }
    },
    filterSearchResults: function() {
      $('.search-results-list').removeClass('terminal-filter-active');
      $('.search-result:not(.always-visible)').removeClass('selected-terminal');

      var terminal = wf.terminalFilters.getSelectedTerminal();
      if (terminal !== 'all') {
        $('.search-results-list').addClass('terminal-filter-active');
      }

      $('.search-result.' + terminal).addClass('selected-terminal');
    },
    filterFlightListing: function() {
      $('.flight-list').removeClass('terminal-filter-active');
      $('.flight-list tbody tr').removeClass('selected-terminal');

      var terminal = wf.terminalFilters.getSelectedTerminal();
      if (terminal !== 'all') {
        $('.flight-list').addClass('terminal-filter-active');
        $(".flight-list tbody tr[data-terminal='" + terminal + "']").addClass(
          'selected-terminal'
        );
      }
    },
  },
  promotions: {
    init: function() {
      wf.promotions.hidePromotion();
    },
    hidePromotion: function() {
      $('.promotion__close').on('click', function(e) {
        e.preventDefault();
        wf.cookie(wf.flights.airportCode + '_promo-hidden', true, 2);
        $(this)
          .parents('.promotion')
          .attr('hidden', '');
      });
    },
  },
  modalVideo: {
    init: function() {
      wf.modalVideo.loadYouTubeAPI();
      wf.modalVideo.bindModalControls();
    },
    loadYouTubeAPI: function() {
      var videos = $('.modal-video');
      if (videos.length) {
        wf.loadJS('https://www.youtube.com/iframe_api');
      }
    },
    bindModalControls: function() {
      const modalTriggers = [
        ...document.querySelectorAll(
          '.modal-video__play, .modal-video__close, .modal-video'
        ),
      ];
      modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', wf.modalVideo.handleModalInteraction);
      });

      // $('.modal-video__play, .modal-video__close, .modal-video').on(
      //   'click',
      //   wf.modalVideo.handleModalInteraction
      // );

      $(document).on('keyup', wf.modalVideo.handleModalInteraction);
    },
    handleModalInteraction: function(e) {
      e.stopPropagation();

      if (e.type === 'keyup' && e.keyCode !== 27) {
        return false;
      }

      var modal = document.querySelector(".modal-video[aria-hidden='false']");

      switch (e.target.className) {
        case 'modal-video__play':
          e.preventDefault();
          modal = e.target.nextElementSibling;
          break;
        case 'modal-video':
          modal = e.target;
          break;
        case 'modal-video__close':
          modal = e.target.parentElement.parentElement;
          break;
      }

      wf.modalVideo.toggleModalVisibility(modal);
    },
    toggleModalVisibility(modal) {
      var hidden = modal.getAttribute('aria-hidden');

      if (hidden == 'true') {
        modal.setAttribute('aria-hidden', 'false');
        wf.modalVideo.playVideo(modal);
      } else {
        modal.setAttribute('aria-hidden', 'true');
        wf.modalVideo.pauseVideo(modal);
      }
    },
    playVideo: function(modal) {
      var videoId = modal.dataset.videoId;
      var modalVideos = window.modalVideos || {};

      if (modalVideos && modalVideos[videoId]) {
        return modalVideos[videoId].playVideo();
      }

      var player = new window.YT.Player('player-' + videoId, {
        videoId: videoId,
        width: 1280,
        height: 720,
        playerVars: {
          cc_load_policy: 0,
          showinfo: 0,
          modestbranding: 1,
          iv_load_policy: 3,
          autoplay: 1,
          rel: 0,
        },
      });

      player.addEventListener('onReady', function() {
        player.playVideo();
      });

      modalVideos[videoId] = player;
      window.modalVideos = modalVideos;
    },
    pauseVideo: function(modal) {
      var videoId = modal.dataset.videoId;
      var modalVideos = window.modalVideos;
      if (modalVideos && modalVideos[videoId]) {
        modalVideos[videoId].pauseVideo();
      }
    },
  },
};

// wf.flights.init();
// wf.flights.cleanupStoredData();
wf.navigation.init();
wf.page.init();
wf.search.init();
wf.terminalFilters.init();
wf.promotions.init();
wf.modalVideo.init();
wf.products.init();

//Resize functions
var resizeStart = new Date(),
  timeout = false,
  delay = 200;

function resizeEnd() {
  if (new Date() - resizeStart < delay) {
    setTimeout(resizeEnd, delay);
  } else {
    // Add any scripts that need to trigger on end of window resize here
    timeout = false;
    wf.page.mobileMapZoom();
  }
}

$(window)
  .resize(function() {
    resizeStart = new Date();

    if (timeout === false) {
      timeout = true;
      setTimeout(resizeEnd, delay);
    }
  })
  .on('load', function() {
    wf.page.scrollToSection();
  });

window.wf = wf;
